import _get from 'lodash/get'
export const parseSortBy = function(queryVal) {
  let firstChar = _get(queryVal, '[0]')
  if (!firstChar) return ''
  let isFirstCharDash = queryVal[0] === '-'
  return queryVal ? queryVal.slice(+isFirstCharDash) : queryVal
}
export const parseSortDesc = function(queryVal) {
  if (!queryVal) return false
  let isFirstCharDash = queryVal[0] === '-'
  return isFirstCharDash
}

export default { parseSortBy, parseSortDesc }
